import { difference, union } from '../../../dependencies';
import { types } from '../../actions';

const initialState = {
    byId: {},
    ids: [],
};

export default function exportsReducer(state = initialState, action) {
    switch (action.type) {
        case types.FETCH_EXPORTS_SUCCESS: {
            const { ids, byId } = action.payload;
            return {
                ...state,
                byId,
                ids,
            };
        }

        case types.CREATE_EXPORT_SUCCESS:
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.payload.id]: action.payload,
                },
                ids: union(state.ids, [action.payload.id]),
            };

        case types.UPDATE_EXPORT_SUCCESS:
        case types.FETCH_EXPORT_SUCCESS:
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.meta.id]: action.payload,
                },
            };

        case types.DELETE_EXPORT_SUCCESS:
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.meta.id]: undefined,
                },
                ids: difference(state.ids, [action.meta.id]),
            };

        default:
            return state;
    }
}
